import { endlessPaginate } from "endless_pagination/endless-pagination-module.js";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	endlessPaginate();
	// gallery video
	const video_gallery = document.querySelector("#_video-gallery");
	for (const el of document.querySelectorAll("._video-album")) {
		el.addEventListener("click", (event) => {
			event.preventDefault();
			for (const album of document.querySelectorAll("._video-album")) {
				album.classList.remove("active");
			}
			const target = event.currentTarget;
			target.classList.add("active");
			fetch(`${window.location.pathname}${target.dataset.album}/`, {
				headers: {
					"X-Requested-With": "XMLHttpRequest",
				},
			})
				.then((response) => response.text())
				.then((data) => {
					if (data) {
						video_gallery.innerHTML = data;
						scroll({
							top: video_gallery.offsetTop - 100,
							behavior: "smooth",
						});
					}
				})
				.catch((error) => {
					console.warn(error);
				});
		});
	}
});
